import { render, staticRenderFns } from "./SecurityCourseModal.vue?vue&type=template&id=b9fc4b42&scoped=true"
import script from "./SecurityCourseModal.vue?vue&type=script&lang=js"
export * from "./SecurityCourseModal.vue?vue&type=script&lang=js"
import style0 from "./SecurityCourseModal.vue?vue&type=style&index=0&id=b9fc4b42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fc4b42",
  null
  
)

export default component.exports